// Angular
import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// Lodash
import { each, find, some } from 'lodash';
// NGRX
import { Update } from '@ngrx/entity';
import { Store, select } from '@ngrx/store';
// State
import { AppState } from '../../../../core/reducers';
// Services and Models
import {
	User,
	Project,
	Address,
	Drawing,
	Customer
} from '../../../../core/auth';
import { LayoutUtilsService, MessageType, TypesUtilsService } from '../../../../core/_base/crud';
import { delay } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
// RxJS
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
// import { stringify } from 'querystring';
import { ProjectService } from '../../services/project.service';
import { DrawingService } from '../../services/drawing.service';
import { CustomersService } from '../../services/customers.service';
import { DatePipe } from '@angular/common';
import { map, startWith } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DepthOption, getDepthOptions } from '../../../../core/auth/_models/depth-option.model';
@Component({
	selector: 'kt-project-edit-dialog',
	templateUrl: './project-edit.dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Default,
	providers: [DatePipe]
})
export class ProjectEditDialogComponent implements OnInit, OnDestroy {
	// Public properties
	user: User;
	salePersonCode = '';
	project = new Project();
	project$: Observable<Project>;
	oldProject: Project;
	formType: string[] = ['Form 1', 'Form 2a', 'Form 2b', 'Form 3a', 'Form 3b', 'Form 4a', 'Form 4b'];
	voltage: string[] = ['250A', '400A', '630A', '800A', '1000A', '1200A', '1600A', '2000A', '2500A', '3200A', '4000A', '5000A', '6300A'];
	busbarLocation: string[] = ['Back', 'Top', 'Bottom'];
	cabledirection: string[] = ['Top', 'Bottom', 'Top & Bottom'];
	shortCircuitTime: string[] = ['100kA/1S', '85kA/1S', '75kA/1S', '65kA/1s', '50kA/1S'];
	earthingSystem: string[] = ['TN-S', 'TN-C', 'TN', 'IT'];
	iecStandard: string[] = ['61439'];
	ipRating: string[] = ['IP42', 'IP43', 'IP54', 'IP55'];
	colour: string[] = ['RAL 7032', 'RAL 7035', 'RAL 2000', 'RAL 9005', 'OTHER COLORS'];
	selectValue: any;
	updatedProject: Project;
	selectedItems: any;
	depthOptionIndex = 0;
	filteredVoltageOptions: Observable<string[]>;

	depthoption: DepthOption[] = getDepthOptions();
	loading$: Observable<boolean>;
	addressSubject = new BehaviorSubject<Address>(new Address());
	projectForm: FormGroup;
	hasFormErrors = false;
	isEdit = false;
	// Private properties
	private subscriptions: Subscription[] = [];
	userName: any;
	//dataSource: any;
	dataSource = new MatTableDataSource();
	loadedCustomers: Customer[] = [];
	myControl = new FormControl('', Validators.required);
	shortCircuitControl = new FormControl('');
	customerData;
	myDate = new Date();
	loadedProject: Project[];
	referenceId: string;
	dformt: any;
	email: any;
	selectedCustomerId: string | null = null;
	customerNameInputData: string = '';
	role: string;
	distributorCompanyName: string;
	IsKikMember: boolean;
	userid: any;
	isDirectCustomer: boolean;
	PrebuildTierCompletedDrawing: boolean;
	loading = false;
	filteredCustomers: Observable<Customer[]>; // Replace any with your customer type
	filteredShortCircuitOptions: Observable<any[]>;

	/**
	 * Component constructor
	 *
	 * @param activatedRoute: ActivatedRoute
	 * @param router: Router
	 * @param userFB: FormBuilder
	 * @param subheaderService: SubheaderService
	 * @param layoutUtilsService: LayoutUtilsService
	 * @param store: Store<AppState>
	 * @param layoutConfigService: LayoutConfigService
	 */
	//  colurs = new FormControl({value:'RAL 7032'})


	constructor(private activatedRoute: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private projectFB: FormBuilder,
		private layoutUtilsService: LayoutUtilsService,
		public dialogRef: MatDialogRef<ProjectEditDialogComponent>,
		public projectService: ProjectService,
		public drawingService: DrawingService,
		private customerService: CustomersService,
		public typeUtil: TypesUtilsService,
		private cdr: ChangeDetectorRef,
		private userService: UserService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private store: Store<AppState>
	) {


		this.projectService.getAll().subscribe(res => {
			this.loadedProject = res;
			this.referenceId = this.ProjectRefNo('KIK2D-' + this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + '-', String(this.loadedProject.length + 1), '0', 3);

		});

		this.userid = localStorage.getItem('userId');
		this.userService
			.getUserById(this.userid)
			.subscribe(
				(user) => {
					this.role = user.role
					this.distributorCompanyName = user.distributorCompanyName
					this.IsKikMember = user.isKikMember
					this.isDirectCustomer = user.isDirectCustomer

				},
				(error) => {
					console.error(
						'Error fetching users by userId',
						error
					);
				}
			);

		this.customerList();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		if (this.data.preBuildTier) {
			console.log("this.data.preBuildTier", this.data.preBuildTier);
			this.PrebuildTierCompletedDrawing = this.data.preBuildTier;
			this.selectedItems = this.data.selectedItems;
		}
		this.customerList();
		this.filteredCustomers = this.myControl.valueChanges.pipe(
			startWith(''),
			map(value => value ? this._filterCustomers(value) : this.loadedCustomers.slice())
		);

		this.email = localStorage.getItem('email');
		this.userService.getUserByEmail(this.email).subscribe(
			res => {
				if (res) {
					this.user = res;
					this.user.fullname = res.fullname;
					this.salePersonCode = this.generateSalePersonCode(this.user.fullname);
				}
			}
		);

		this.userName = localStorage.getItem('username');
		this.initProject();
		this.filteredVoltageOptions = this.projectForm.get('voltage').valueChanges.pipe(
			startWith(''),
			map(value => this._filterVoltageOptions(value || ''))
		);

		if (this.data.projectId) {
			this.projectService.getProjectById(this.data.projectId).subscribe(res => {
				if (res) {
					this.isEdit = true;
					this.project = res;
					this.project.address.email = (res.address && res.address.email) ? res.address.email : '';
					this.project.address.telephone = (res.address && res.address.telephone) ? res.address.telephone : (res.telephone || '');
					this.project.address.mobile = (res.address && res.address.mobile) ? res.address.mobile : (res.mobile || '');
					this.project.cabledirection = res.cabledirection ? res.cabledirection : '';
					this.project.userId = res.userId ? res.userId : '';
					this.project.designer = res.designer;
					this.oldProject = Object.assign({}, this.project);
					this.myControl.setValue(this.project.customerName);
					if (res.depthoption) {
						const desiredValue = res.depthoption;
						const index = this.depthoption.findIndex(option =>
							option.component === desiredValue.component &&
							option.busbar === desiredValue.busbar &&
							option.total === desiredValue.total
						);
						if (index !== -1) {
							this.depthOptionIndex = index;
						} else {
							console.log(`'${JSON.stringify(desiredValue)}' not found in depthoption array.`);
						}
					} else {
						console.log('depthoption array is empty or undefined.');
					}
					this.setFormValue(this.project);
				}
			});
		} else {
			this.isEdit = false;
			const newProject = new Project();
			newProject.clear();
			this.oldProject = Object.assign({}, this.project);
			this.setFormValue(newProject);

			setTimeout(() => {
				this.projectForm.patchValue({
					customerName: 'John Doe',
					address: {
						addressLine: 'Demo Address',
						country: 'Demo country',
						telephone: '0123456789',
						city: 'Demo City'
					}
				});
				this.myControl.setValue('John Doe');
			}, 1000); // 1 seconds delay
		}

		// Call setDefultValueOf but prevent it from overriding customerName
		this.setDefultValueOf();
		this.shortCircuitControl.setValue('65kA/1s');
		this.filteredShortCircuitOptions = this.shortCircuitControl.valueChanges.pipe(
			startWith(''),
			map(value => this._filterShortCircuitOptions(value || ''))
		);
	}

	generateSalePersonCode(fullname: string): string {
		const words = fullname.split(' ');

		if (words.length === 1) {
			return words[0].slice(0, 2).toUpperCase();
		} else if (words.length >= 2) {
			const initials = words.map(word => word.charAt(0).toUpperCase());
			return initials.join('');
		} else {
			return '';
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}

	ProjectRefNo(Sym: string, text: string, padChar: string, size: number): string {
		return Sym + (String(padChar).repeat(size) + text).substr((size * -1), size);
	}


	customerList() {
		this.customerService.getAllCustomers().subscribe(res => {
			//this.loadedCustomers =res.filter(o => o.email === 'kik@kik.lk');
			//this.loadedCustomers =res.filter(o => o.email === 'kik@kik.lk');
			var data = res;
			if (this.role === 'superadmin') {
				this.loadedCustomers = res
			} else {
				this.filterDataByRole(data);
			}
		});

	}
	private filterDataByRole(data: Customer[]): void {
		if (this.role === 'admin' || this.role === 'localuser') {
			this.filterDataForAdminAndLocalUser(data);
		} else {
			this.loadedCustomers = data.filter((o) => o.userId === this.userid);
		}
	}
	private filterDataForAdminAndLocalUser(data: Customer[]): void {
		const distributorCompanyName = this.distributorCompanyName;

		if (distributorCompanyName && distributorCompanyName.length) {
			this.filterDataByDistributionCompanyName(data, distributorCompanyName);
		} else if (this.IsKikMember === true) {
			const IsKikMember = this.IsKikMember
			if (IsKikMember !== null) {
				this.filterDataByKikMembers(data, IsKikMember);
			}
		} else {
			this.loadedCustomers = data.filter((o) => o.userId === this.userid);
		}
	}

	/**
	 * Filter data by distribution company name
	 */
	private filterDataByDistributionCompanyName(
		data: Customer[],
		distributorCompanyName: string
	): void {
		this.userService
			.getUsersByDistributionCompanyName(distributorCompanyName)
			.subscribe(
				(users) => {
					let filteredUserIds: string[] = this.getFilteredUsersId(users);
					this.loadedCustomers = data.filter((customer) =>
						filteredUserIds.includes(customer.userId)
					);
				},
				(error) => {
					console.error(
						'Error fetching users by distribution company name',
						error
					);
				}
			);
	}

	private filterDataByKikMembers(data: Customer[], IsKikMember: boolean): void {
		this.userService.getKikMembers(IsKikMember).subscribe(
			(kikMembers) => {
				if (this.role === 'admin') {
					this.userService.getDirectCustomers(this.isDirectCustomer).subscribe(
						(directCustomers) => {
							const kikMemberUserIds = this.getFilteredUsersId(kikMembers);
							const directCustomerUserIds = this.getFilteredUsersId(directCustomers);
							let filteredUserIds: string[] = kikMemberUserIds.concat(directCustomerUserIds);
							this.loadedCustomers = data.filter((customer) =>
								filteredUserIds.includes(customer.userId)
							);
						},
						(error) => {
							console.error('Error fetching Direct customers', error);
						}
					);
				} else if (this.role === 'localuser') {
					const kikMemberUserIds = this.getFilteredUsersId(kikMembers);
					this.loadedCustomers = data.filter((customer) =>
						kikMemberUserIds.includes(customer.userId)
					);
				}
			},
			(error) => {
				console.error('Error fetching Kik members', error);
			}
		);
	}


	/**
	 * Get filtered usernames based on user role
	 */
	private getFilteredUsersId(users: any[]): string[] {
		let filteredUserIds: string[] = [];
		if (users !== null) {
			filteredUserIds = users.map((user) => user.uuid);
		}
		return filteredUserIds;
	}

	// ProjectList(){
	// 	this.projectService.getAll().subscribe(res=>{
	//      this.loadedProject=res;
	// 	 console.log(this.loadedProject.length);
	// 	});


	// }


	/**
	 * Init user
	 */
	initProject() {
		this.createForm();
	}

	/**
	 * Create form
	 */
	createForm() {
		this.projectForm = this.projectFB.group({
			title: ['', [Validators.required]],
			designer: [],
			approvedBy: [],
			customerName: (this.role === 'superadmin' || this.IsKikMember)
				? this.myControl
				: [],
			// customerId: [],	
			address: this.projectFB.group({
				addressLine: ['', [Validators.required]],
				city: [],
				state: [],
				country: ['', [Validators.required]],
				email: [],
				postCode: [],
				telephone: ['', [Validators.required, this.validateTelephoneOrMobile]],
				mobile: ['', [this.validateTelephoneOrMobile]],
			}),
			telephone: [],
			mobile: [],
			earthingSystem: [],
			iecStandard: [],
			ipRating: [],
			orginDate: [],
			formType: ['', [Validators.required]],
			voltage: ['', [Validators.required]],
			busbarLocation: [],
			cabledirection: [],
			shortCircuitTime: (this.role === 'superadmin' || this.IsKikMember)
				? this.shortCircuitControl
				: [],
			version: [],
			colour: [],
			innerProfileColour: [],
			discount: [null],
			frightCharges: [],
			shipmentMode: [],
			portName: [],
			panelname: ['', [Validators.required]],
			specialNote: [],

			depthoption: ['', [Validators.required]],
		});


		this.setDefultValueOf();


	}
	setDefultValueOf() {
		this.projectForm.patchValue({
			title: 'New Electrical Project',
			panelname: 'Main Distribution Panel',
			colour: this.colour[1],
			innerProfileColour: this.colour[1],
			earthingSystem: this.earthingSystem[1],
			formType: this.formType[4],
			busbarLocation: this.busbarLocation[1],
			cabledirection: this.cabledirection[1],
			shortCircuitTime: this.shortCircuitTime[3],
			depthoption: this.depthoption[5],
			voltage: this.voltage[7],
			iecStandard: this.iecStandard[0],
			ipRating: this.ipRating[2],
			orginDate: this.datePipe.transform(this.myDate, 'yyyy-MM-dd')
		});

	}
	setFormValue(project: Project) {
		this.projectForm.setValue({
			title: project.title,
			designer: this.project.designer || this.userName,
			approvedBy: project.approvedBy || '',
			customerName: project.customerName || '',
			address: {
				addressLine: project.address?.addressLine || '',
				city: project.address?.city || '',
				state: project.address?.state || '',
				country: project.address?.country || '',
				postCode: project.address?.postCode || '',
				email: project.address?.email || '',
				telephone: project.address?.telephone || '',
				mobile: project.address?.mobile || '',
			},
			telephone: project.telephone || '',
			mobile: project.mobile || '',
			earthingSystem: project.earthingSystem || '',
			iecStandard: project.iecStandard || '',
			ipRating: project.ipRating || '',
			orginDate: project.orginDate || this.datePipe.transform(this.myDate, 'yyyy-MM-dd'),
			formType: (this.role === 'superadmin' || this.IsKikMember)
				? (project.formType === 'Form 4a' ? 'Form 4a Type 1' :
					(project.formType === 'Form 4b' ? 'Form 4b Type 4' : project.formType || this.formType[4]))
				: project.formType || this.formType[4],
			voltage: project.voltage || this.voltage[7],
			busbarLocation: project.busbarLocation || this.busbarLocation[1],
			cabledirection: project.cabledirection || this.cabledirection[1],
			shortCircuitTime: project.shortCircuitTime || this.shortCircuitTime[3],
			version: project.version || '',
			colour: project.colour || this.colour[1],
			innerProfileColour: project.innerProfileColour || this.colour[1],  // ← FIX: Add fallback value
			discount: project.discount || '',
			frightCharges: project.frightCharges || '',
			shipmentMode: project.shipmentMode || '',
			portName: project.portName || '',
			panelname: project.panelname || '',
			specialNote: project.specialNote || '',
			depthoption: this.depthoption[this.depthOptionIndex] || this.depthoption[5],
		});
	}
	/**
	 * Redirect to list
	 *
	 */
	goBackWithId() {
		const url = `/user-management/users`;
		this.router.navigateByUrl(url, { relativeTo: this.activatedRoute });
	}

	/**
	 * Refresh user
	 *
	 * @param isNew: boolean
	 * @param id: number
	 */
	refreshUser(isNew: boolean = false, id = 0) {
		let url = this.router.url;
		if (!isNew) {
			this.router.navigate([url], { relativeTo: this.activatedRoute });
			return;
		}

		url = `/user-management/users/edit/${id}`;
		this.router.navigateByUrl(url, { relativeTo: this.activatedRoute });
	}

	/**
	 * Reset
	 */
	reset() {
		this.project = Object.assign({}, this.oldProject);
		this.createForm();
		this.hasFormErrors = false;
		this.projectForm.markAsPristine();
		this.projectForm.markAsUntouched();
		this.projectForm.updateValueAndValidity();
	}

	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSumbit(withBack: boolean = false) {
		this.hasFormErrors = false;
		const controls = this.projectForm.controls;
		/** check form */
		if (this.projectForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}



		if (this.isEdit) {
			const editedProject = this.prepareProjectforUpdate();
			this.updateProject(editedProject, withBack);
		} else {
			const createdProject = this.prepareNewProject();
			this.addProject(createdProject, withBack);
		}

	}

	/**
	 * Returns prepared data for save
	 */
	prepareProjectforUpdate(): Project {
		if (this.myControl.value) {
			this.getTypedCustomerData(this.myControl.value);
		}
		const controls = this.projectForm.controls;
		const _project = new Project();
		_project.clear();

		_project._id = this.project._id;
		_project.uuid = this.project.uuid;
		_project.address = controls.address.value;
		_project.title = controls.title.value;
		this.projectService.changeTitle(_project.title);
		_project.designer = this.project.designer;
		_project.approvedBy = controls.approvedBy.value;
		if (this.customerData && Object.keys(this.customerData).length > 0) {
			_project.customerName = this.customerData.customername;
			_project.customerId = this.customerData.uuid;
		} else {
			// Handle the case where customerData is not defined
			_project.customerName = '';
			_project.customerId = '';
		}
		_project.referenceId = this.project.referenceId;
		_project.drawingId = this.project.drawingId;
		_project.telephone = controls.telephone.value;
		_project.mobile = controls.mobile.value;
		_project.earthingSystem = controls.earthingSystem.value;
		_project.iecStandard = controls.iecStandard.value;
		_project.ipRating = controls.ipRating.value;
		_project.orginDate = controls.orginDate.value;
		_project.formType = controls.formType.value;
		_project.voltage = controls.voltage.value;
		_project.busbarLocation = controls.busbarLocation.value;
		_project.cabledirection = controls.cabledirection.value;
		_project.shortCircuitTime = controls.shortCircuitTime.value;
		_project.version = controls.version.value;
		_project.colour = controls.colour.value;
		_project.innerProfileColour = controls.innerProfileColour.value;
		_project.discount = controls.discount.value;
		_project.frightCharges = controls.frightCharges.value;
		_project.shipmentMode = controls.shipmentMode.value;
		_project.portName = controls.portName.value;
		_project.panelname = controls.panelname.value;
		_project.specialNote = controls.specialNote.value;
		_project.depthoption = controls.depthoption.value;
		_project.salePersonCode = this.salePersonCode;
		_project.userId = this.project.userId;
		const draw = new Drawing();
		draw.uuid = _project.drawingId;
		draw.depthoption = _project.depthoption;
		this.drawingService.updateDiagram(draw).subscribe(res => {
		});
		return _project;
	}


	prepareNewProject(): Project {
		if (this.myControl.value) {
			this.getTypedCustomerData(this.myControl.value);
		}

		const controls = this.projectForm.controls;
		const _project = new Project();
		_project.clear();
		_project.uuid = this.typeUtil.generateUUID();
		_project.address = controls.address.value;
		_project.title = controls.title.value;
		_project.designer = this.userName;
		_project.approvedBy = controls.approvedBy.value;
		// Add a null check for this.customerData
		if (this.customerData && Object.keys(this.customerData).length > 0) {
			_project.customerName = this.customerData.customername;
			_project.customerId = this.customerData.uuid;
		} else {
			// Handle the case where customerData is not defined
			_project.customerName = '';
			_project.customerId = '';
		}
		_project.referenceId = this.referenceId;
		_project.drawingId = this.typeUtil.generateUUID();
		_project.telephone = controls.telephone.value;
		_project.mobile = controls.mobile.value;
		_project.earthingSystem = controls.earthingSystem.value;
		_project.iecStandard = controls.iecStandard.value;
		_project.ipRating = controls.ipRating.value;
		_project.orginDate = controls.orginDate.value;
		_project.formType = controls.formType.value;
		_project.voltage = controls.voltage.value;
		_project.busbarLocation = controls.busbarLocation.value;
		_project.cabledirection = controls.cabledirection.value;
		_project.shortCircuitTime = controls.shortCircuitTime.value;
		_project.version = controls.version.value;
		_project.colour = controls.colour.value;
		_project.innerProfileColour = controls.innerProfileColour.value;
		_project.discount = 0
		_project.frightCharges = 0;
		_project.shipmentMode = '-'
		_project.portName = 'CIF';
		_project.specialNote = '-';
		_project.panelname = controls.panelname.value;
		_project.depthoption = controls.depthoption.value;
		_project.salePersonCode = this.salePersonCode;
		_project.userId = this.userid;
		const draw = new Drawing();
		draw.uuid = _project.drawingId;
		draw.projectId = _project.uuid;
		draw.depthoption = _project.depthoption;
		draw.nodeDataArrayJSON = `{ "class": "GraphLinksModel",
		"nodeKeyProperty": "uuid",
		"linkKeyProperty": "uuid",
		"linkFromPortIdProperty": "fromPort",
		"linkToPortIdProperty": "toPort",
		"nodeDataArray": [],
		"linkDataArray": []}`;
		this.drawingService.createDiagram(draw).subscribe(res => {

		});
		return _project;
	}

	/**
	 * Add User
	 *
	 * @param _user: User
	 * @param withBack: boolean
	 */
	addProject(_project: Project, withBack: boolean = false) {
		if (this.customerNameInputData && this.customerNameInputData.length > 0) {
			if (this.selectedCustomerId && this.selectedCustomerId.length > 0) {
				const updatedProject = {
					..._project,
					customerId: this.selectedCustomerId
				} as Project;
				this.projectService.createProject(updatedProject).subscribe(res => {
					this.dialogRef.close();
					const url = `/drawing`;
					if (!this.PrebuildTierCompletedDrawing) {
						this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid } });
					}
					else {
						this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems, PrebuildTierCompletedDrawing: this.PrebuildTierCompletedDrawing } });
					}
				});
			} else {
				const updatedProject = {
					..._project,
					customerName: this.customerNameInputData
				} as Project;

				this.projectService.createProject(updatedProject).subscribe(res => {
					this.dialogRef.close();
					const url = `/drawing`;
					if (!this.PrebuildTierCompletedDrawing) {
						this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid } });
					} else {
						this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems, PrebuildTierCompletedDrawing: this.PrebuildTierCompletedDrawing } });
					}
				});
			}

		} else {
			this.projectService.createProject(_project).subscribe(res => {
				this.dialogRef.close();
				const url = `/drawing`;
				if (!this.PrebuildTierCompletedDrawing) {
					this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid } });
				} else {
					this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems } });
				}
			});
		}
	}


	/**
	 * Update user
	 *
	 * @param _user: User
	 * @param withBack: boolean
	 */
	updateProject(_project: Project, withBack: boolean = false) {

		if (this.customerNameInputData && this.customerNameInputData.length > 0) {
			if (this.selectedCustomerId && this.selectedCustomerId.length > 0) {
				const updatedProject = {
					..._project,
					customerId: this.selectedCustomerId
				} as Project;
				this.updatedProject = updatedProject;
				this.projectService.updateProject(updatedProject).subscribe(res => {
				},
					err => {
						console.log(err);
					}
				);
			} else {
				const updatedProject = {
					..._project,
					customerName: this.customerNameInputData
				} as Project;
				this.updatedProject = updatedProject;
				this.projectService.updateProject(updatedProject).subscribe(res => {

				}, err => {
					console.log(err);
				});
			}
		} else {
			const updatedProject = {
				..._project,
			} as Project;
			this.updatedProject = updatedProject;
			this.projectService.updateProject(_project).subscribe(res => {
			},
				err => {
					console.log(err);
				}
			);


		}
		this.dialogRef.close(this.updatedProject);

		// const message = `User successfully has been saved.`;
		// this.layoutUtilsService.showActionNotification(message, MessageType.Update, 5000, true, true);
		// // const updatedProject: Update<Project> = {
		// 	id: _project.id,
		// 	changes: _project
		// };
		// this.store.dispatch(new UserUpdated( { partialUser: updatedUser, user: _user }));
		// const message = `User successfully has been saved.`;
		// this.layoutUtilsService.showActionNotification(message, MessageType.Update, 5000, true, true);
		// if (withBack) {
		// 	this.goBackWithId();
		// } else {
		// 	this.refreshUser(false);
		// }
	}

	/**
	 * Returns component title
	 */
	getComponentTitle() {
		let result = 'Project Information';
		if (!this.project || !this.project.uuid) {
			return result;
		}

		// result = `Edit project - ${this.project.title}`;
		result = 'Project Information';
		return result;
	}

	/**
	 * Close Alert
	 *
	 * @param $event: Event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	getCustomerDetail(event) {
		this.customerService.getCustomerById(event.value).subscribe(
			res => { //

				this.customerData = res;
				let address = {};
				address['addressLine'] = this.customerData.address.addressLine;
				address['city'] = this.customerData.address.city;
				address['state'] = this.customerData.address.state;
				address['country'] = this.customerData.address.country;
				address['postCode'] = this.customerData.address.postCode;
				address['email'] = this.customerData.address.email;
				address['telephone'] = this.customerData.phone;
				address['mobile'] = this.customerData.fax;
				if (this.role !== 'superadmin' && !this.IsKikMember) {
					this.projectForm.get('customerName').patchValue(this.customerData.customername);
				}
				this.projectForm.get('address').patchValue(address)
				this.projectForm.get('telephone').patchValue(this.customerData.phone)
				this.projectForm.get('mobile').patchValue(this.customerData.fax)
				this.cdr.detectChanges();
				//this.projectForm.get('customerId').patchValue(this.customerAddres.uuid)



			},
			err => { console.log(err) }
		)
	}
	private _filterCustomers(value: string): Customer[] {
		const filterValue = value.toLowerCase().trim();
		return this.loadedCustomers.filter((customer) =>
			customer.customername.toLowerCase().includes(filterValue)
		);
	}

	displayFn(customer: Customer): string {
		return customer ? customer.customername : '';
	}

	displaySelectedCustomer(customerId: string): string {
		const customerNameValue = this.projectForm.get('customerName').value?.toLowerCase();
		let selectedCustomer;

		if (this.role === 'superadmin' || this.IsKikMember) {
			// Logic for superadmin or Kik member
			selectedCustomer = this.loadedCustomers.find(
				customer => customer.uuid?.toLowerCase() === customerId
			);

			if (!selectedCustomer) {
				selectedCustomer = this.loadedCustomers.find(
					customer => customer.customername === customerNameValue
				);
			}
		} else {
			// Logic for other roles
			selectedCustomer = this.loadedCustomers.find(
				customer => customer.customername?.toLowerCase() === customerNameValue
			);
			if (!selectedCustomer) {
				selectedCustomer = this.loadedCustomers.find(
					customer => customer.uuid === customerId
				);
			}
		}
		const customerName = selectedCustomer ? selectedCustomer.customername : '';
		return customerName;
	}


	onCustomerSelected(selectedCustomerId: string) {

		this.selectedCustomerId = selectedCustomerId;


		this.getCustomerDetail({ value: selectedCustomerId });
	}
	displayshortCircuitTime(value: string): string {
		return value ? value : '';
	}
	private _filterShortCircuitOptions(value: string) {
		const filterValue = value.toLowerCase();
		return this.shortCircuitTime.filter(option => option.toLowerCase().includes(filterValue));
	}
	onCustomerNameInput(inputData: string) {
		if (this.selectedCustomerId) {
		} else {

			this.customerNameInputData = inputData;
		}
	}
	getTypedCustomerData(inputData: string) {
		this.customerNameInputData = inputData;

		this.customerData = this.loadedCustomers.find(customer => customer.customername === this.customerNameInputData);

		if (!this.customerData) {
			this.customerData = this.loadedCustomers.find(customer => customer.uuid === this.customerNameInputData);
		}

		if (!this.customerData) {
			this.customerData = {}; // Set to an empty object
		} else {
			console.log("inputCustomerData", this.customerData);
		}

		return this.customerData;
	}

	validateTelephoneOrMobile(control: FormControl) {
		const inputValue = control.value;
		if (
			inputValue &&
			!/^\+?[0-9+()&[\]*#\-/. ]*$/.test(inputValue) // Allow "+" at the start and other valid characters
		) {
			return { invalidNumber: true };
		}
		return null;
	}
	onTelephoneInput(event: any) {
		const inputValue = event.target.value;
		const sanitizedValue = inputValue
			.replace(/[^0-9+()&[\]*#\-/. ]/g, '') // Remove invalid characters
			.replace(/(?!^\+)\+/g, ''); // Allow "+" only at the beginning
		event.target.value = sanitizedValue;
	}

	private _filterVoltageOptions(value: string): string[] {
		const filterValue = value.toLowerCase().trim();
		return this.voltage.filter(option =>
			option.toLowerCase().includes(filterValue)
		);
	}
}


